const PRIVATE_ASSETS = new Set(['monero'])

const createOrdersReport = ({ ordersAtom }) => ({
  namespace: 'orders',
  export: async ({ walletExists } = Object.create(null)) => {
    if (!walletExists) return null

    const ordersData = await ordersAtom.get()
    const redactedData = ordersData.toRedactedJSON()
    const ordersWithoutPrivateAssets = redactedData.filter(
      ({ fromAsset, toAsset }) => !PRIVATE_ASSETS.has(fromAsset) && !PRIVATE_ASSETS.has(toAsset)
    )

    return { data: ordersWithoutPrivateAssets }
  },
})

const ordersReportDefinition = {
  id: 'ordersReport',
  type: 'report',
  factory: createOrdersReport,
  dependencies: ['ordersAtom'],
  public: true,
}

export default ordersReportDefinition
